import * as React from 'react';
import { usePromptStarterList_unstable } from './usePromptStarterList';
import { renderPromptStarterList_unstable } from './renderPromptStarterList';
import { usePromptStarterListStyles_unstable } from './usePromptStarterListStyles.styles';
import type { PromptStarterListProps } from './PromptStarterList.types';
import type { ForwardRefComponent } from '@fluentui/react-components';
import { usePromptStarterListContextValues } from './usePromptStarterListContextValues';

export const PromptStarterList: ForwardRefComponent<PromptStarterListProps> = React.forwardRef((props, ref) => {
  const state = usePromptStarterList_unstable(props, ref);
  const contextValues = usePromptStarterListContextValues(state);

  usePromptStarterListStyles_unstable(state);
  return renderPromptStarterList_unstable(state, contextValues);
});

PromptStarterList.displayName = 'PromptStarterList';
